module.exports = __webpack_public_path__ + "b969cd5d.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_mini_calendar.png
// module id = 1280
// module chunks = 0 1